export default __webpack_public_path__ + "static/access-app-58bf5c3bdcba979417270e3fc5ce6b20.png";